import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var _templateObject;
const SvgComponent = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M30 6A24 24 0 116 30 24 24 0 0130 6m0-6a30 30 0 1030 30A30 30 0 0030 0z",
      stroke: "none"
    }), /*#__PURE__*/jsx("circle", {
      cx: 30.05,
      cy: 15.3,
      r: 4.13,
      stroke: "none"
    }), /*#__PURE__*/jsx("path", {
      d: "M43.7 20.28H16.41a2.18 2.18 0 100 4.37h8a1.49 1.49 0 011.22 1 9 9 0 01-.06 4.08l-2.82 15.75a2.18 2.18 0 104.29.76l1.7-9.73c.2-1 .72-2.45 1.27-2.45h.09c.62 0 1.12 1.65 1.27 2.45l1.7 9.73A2.18 2.18 0 0035.22 48a2.12 2.12 0 00.38 0 2.18 2.18 0 001.77-2.53l-2.79-15.74a9 9 0 01-.06-4.08 1.48 1.48 0 011.18-1h8a2.18 2.18 0 100-4.37z",
      stroke: "none"
    })]
  });
};
const IconGymFeatureBodyTrak = /*#__PURE__*/styled(SvgComponent).withConfig({
  displayName: "GymFeatureBodyTrak__IconGymFeatureBodyTrak",
  componentId: "sc-1461g7y-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  vertical-align: middle;\n"])));

export { IconGymFeatureBodyTrak };
